import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { timeout } from "@app/class/Utilities";
import { IUser } from "@interfaces/IUser";
import { UserRole } from "@services/accountFeature.service";
import { CurrentUserService } from "@services/currentUser.service";
import { DisplayService, IDialogOptionsJson } from "@services/display.service";
import { TranslationService } from "@services/translation.service";
import { AlertReviewStatus } from "src/app/main/modules/alerts/_enums/AlertReviewStatus.enums";
import { IAlertResolutionCode } from "src/app/main/modules/alerts/_models/IAlertResolutionCode";
import { IAlertReviewEvent } from "src/app/main/modules/alerts/_models/IAlertReviewEvent";
import { IAlertReviewHistory } from "src/app/main/modules/alerts/_models/IAlertReviewHistory";
import { AlertReviewService } from "src/app/main/modules/alerts/_services/alert-review.service";
import { AlertsService } from "src/app/main/modules/alerts/_services/alerts.service";
import './alert-review-dialog.component.scss';

@Component({
    selector: 'alert-review-dialog',
    template: require('./alert-review-dialog.component.html')
})
export class AlertReviewDialogComponent implements OnInit {
    @Input() incident: IAlertReviewHistory;
    @Output() addAlertReviewEvent = new EventEmitter<IAlertReviewEvent>();

    loading = false;

    noteText: string = '';

    event: IAlertReviewEvent;
    resolution: IAlertResolutionCode;
    resolutionId: number;
    resolutionCodes: IAlertResolutionCode[];
    agreement = false;

    currentUser: IUser;

    UserRole = UserRole;

    resolvingIncident: boolean;

    constructor(
        private readonly alertReviewService: AlertReviewService,
        private readonly alertsService: AlertsService,
        private readonly currentUserService: CurrentUserService,
        private readonly displayService: DisplayService,
        private readonly translationService: TranslationService) { }

    ngOnInit(): void {
        this.currentUserService.getCurrentUser().then(user => {
            this.currentUser = user;
        })
        this.loadData();
    }

    resolveIncident(): Promise<void> {

        if (this.resolvingIncident) {
            return;
        }

        this.resolvingIncident = true;

        this.event = {
            Status: AlertReviewStatus.Closed,
            Notes: this.noteText,
            AlertReviewHistoryId: this.incident.Id,
            CreatedTime: new Date(),
            UpdatedTime: new Date(),
            UserId: this.currentUser.Id,
            VehicleId: this.incident.VehicleId,
            ResolutionCodeId: this.resolutionId
        };

        return (this.alertReviewService.addAlertReviewEvent(this.event) as Promise<IAlertReviewEvent>).then((alertReviewEvent: IAlertReviewEvent) => {

            this.addAlertReviewEvent.emit(alertReviewEvent);

        }).finally(() => {
            this.resolvingIncident = false;
        });
    }

    openResolutionManagerDialog($event) {
        let dialogHTML = `<resolution-code-editor (delete)="$ctrl.onResCodesChanged()" (add)="$ctrl.onResCodesChanged();"><resolution-code-editor>`;

        const dialogOptions: IDialogOptionsJson = {
            title: this.translationService.t('Alerts.ResolutionCodes'),
            dialogHTML: dialogHTML,
            dialogId: `alertResolutionCodesDialog`,
            bindings: {
                onResCodesChanged: () => { this.onResCodesChanged(); },
            },
            event: $event,
            multiple: true,
            clickOutsideToClose: true,
            escapeToClose: true
        };
        this.displayService.showDialog(dialogOptions);

    }

    onResCodesChanged(): void {
        this.loadData(1000);
    }


    // ---

    private async loadData(delay: number = 0): Promise<void> {

        if (this.loading) {
            return;
        }

        this.loading = true;

        await timeout(delay);

        let promises = [];

        promises.push(this.alertReviewService.getAlertReviewEvents({ AlertReviewHistoryId: this.incident.Id, invalidateCache: true }));
        promises.push(this.alertsService.getAlertResolutionCodes({ invalidateCache: true }));

        Promise.all(promises).then(([alertEvents, resolutionCodes]) => {
            this.alertReviewService.mapEventsToHistory(this.incident, alertEvents);
            this.resolutionCodes = resolutionCodes.filter(c => c.Active);
            this.getResolution();
            this.setupActionForm();
        })
            .finally(() => {
                this.loading = false;
            })
    }

    private setupActionForm() {


        this.event = {
            AlertReviewHistoryId: this.incident.Id,
            CreatedTime: new Date(),
            UpdatedTime: new Date(),
            VehicleId: this.incident.VehicleId,
            ResolutionCodeId: this.resolutionId
        }
    }


    private getResolution() {

        this.resolutionId = this.alertReviewService.getResolutionCode(this.incident);
        if (this.resolutionId) {
            this.resolution = this.resolutionCodes.find(code => code.Id === this.alertReviewService.getResolutionCode(this.incident));
        }
        else {
            this.resolution = this.resolutionCodes[0];
            this.resolutionId = this.resolution.Id;
        }
    }

}
